"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDynamoDBDocClientObjectToJSObject = exports.convertJSObjectToDynamoDBDocClientObject = exports.evalQueryFilters = exports.rowArrayToObjects = exports.objectsToRowArrays = exports.convertDBObjectToJSObject = exports.chunkArray = void 0;
const string_utils_1 = require("./string-utils");
function chunkArray(arr, chunkSize) {
    let results = [];
    while (arr.length) {
        results.push(arr.splice(0, chunkSize));
    }
    return results;
}
exports.chunkArray = chunkArray;
function convertDBObjectToJSObject(dbObject) {
    const jsObject = string_utils_1.convertFromDBColumnNamesToJSVariableNames(dbObject);
    return jsObject;
}
exports.convertDBObjectToJSObject = convertDBObjectToJSObject;
function objectsToRowArrays(objects, includeHeader) {
    const rows = [];
    if (objects.length > 0) {
        const keys = Object.keys(objects[0]);
        if (includeHeader) {
            rows.push(keys);
        }
        objects
            .forEach((obj) => {
            const row = [];
            rows.push(row);
            keys
                .forEach((key) => {
                row.push(obj[key]);
            });
        });
    }
    return rows;
}
exports.objectsToRowArrays = objectsToRowArrays;
function rowArrayToObjects(rows, headers) {
    let objects = [];
    if (rows.length < 1) {
        return objects;
    }
    let rowsToUse = rows;
    if (!headers) {
        // Assume first row is the heaeder row then
        headers = rows[0];
        rowsToUse = rows.slice(1);
    }
    objects = rowsToUse
        .map((row) => {
        return headers === null || headers === void 0 ? void 0 : headers.reduce((obj, header, index) => {
            obj[header] = row[index];
            return obj;
        }, {});
    });
    return objects;
}
exports.rowArrayToObjects = rowArrayToObjects;
function evalOperator(value, operator, conditionValue) {
    if (value) {
        let conditionValueToUse = conditionValue;
        if (typeof value === 'number') {
            conditionValueToUse = Number.parseFloat(conditionValue);
        }
        if (operator === '!=') {
            return value !== conditionValueToUse;
        }
        else if (operator === '<') {
            return value < conditionValueToUse;
        }
        else if (operator === '<=') {
            return value <= conditionValueToUse;
        }
        else if (operator === '>') {
            return value > conditionValueToUse;
        }
        else if (operator === '>=') {
            return value >= conditionValueToUse;
        }
        else if (operator === '=') {
            return value === conditionValueToUse;
        }
        else if (operator === 'IN') {
            return conditionValueToUse.split(',').includes(String(value));
        }
    }
    return false;
}
function evalQueryFilters(obj, queryFilters) {
    if (obj && queryFilters) {
        for (let i = 0; i < queryFilters.length; i++) {
            const qf = queryFilters[i];
            const value = obj[qf.attributeColumn];
            if (!evalOperator(value, qf.operator, qf.value)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
exports.evalQueryFilters = evalQueryFilters;
function convertJSObjectToDynamoDBDocClientObject(object) {
    const items = {};
    for (let key of Object.keys(object)) {
        const dbKey = key.charAt(0).toUpperCase() + key.substring(1);
        const value = object[key];
        if (typeof value === 'boolean') {
            items[dbKey] = String(object[key]);
        }
        else if (typeof value === 'number') {
            items[dbKey] = object[key];
        }
        else if (typeof value === 'string') {
            if (value.length > 0) {
                // Let's not fill up DynamoDB with empty strings...
                items[dbKey] = object[key];
            }
        }
        else {
            throw new Error('Unsupported type:' + key + ' value:' + value);
        }
    }
    ;
    return items;
}
exports.convertJSObjectToDynamoDBDocClientObject = convertJSObjectToDynamoDBDocClientObject;
function convertDynamoDBDocClientObjectToJSObject(item) {
    const obj = {};
    for (const itemKey of Object.keys(item)) {
        const key = itemKey.charAt(0).toLowerCase() + itemKey.substring(1);
        obj[key] = item[itemKey];
    }
    return obj;
}
exports.convertDynamoDBDocClientObjectToJSObject = convertDynamoDBDocClientObjectToJSObject;
//# sourceMappingURL=object-utils.js.map